import { useLocation } from "react-router-dom";
import { BoxTabs } from "../../../components/AntdTab/AntdTab";
import MyTemplates from "./MyTemplates/MyTemplates";
import PublicTemplates from "./PublicTemplates/PublicTemplates";
import { roles } from "../../../config/roles";
import Storage from "../../../utills/AsyncStorage";

const VendorTemplates = () => {
  const { state } = useLocation();
  // console.log("vendorstate??????", state);
  const role = Storage.getERole("@role");

  const items = [
    {
      key: "1",
      label: "My Plannning Forms",
      headerTitle: "Plannning Forms",
      children: <MyTemplates />,
    },
    {
      key: "2",
      label: "Public Planning Forms",
      headerTitle: "Plannning Forms",
      children: <PublicTemplates />,
    },
  ];
  if (role == roles.staff) {
    items.splice(1, 1);
  }

  return (
    <>
      <BoxTabs
        items={items}
        changeHeaderOnTab={true}
        activeKey={state?.activeKey}
      />
    </>
  );
};

export default VendorTemplates;
